import { all, takeEvery } from 'redux-saga/effects';
import {
    FETCH_STATS_HIGHS
} from '../actions';
import { fetchStatsHighs } from './fetch-stats-highs';

export function* lastRoundHighsRootSaga() {
    yield all( [
        // @ts-ignore
        takeEvery( FETCH_STATS_HIGHS.REQUEST, fetchStatsHighs )
    ] );
}